import * as actionTypes from './actionTypes';

import scriptCache from 'Flow2/util/ScriptCache';
import { authCheckState } from './auth';

import * as actions from './index';


export const initStart = () => {
    return {
        type: actionTypes.INIT_START
    };
};

export const initSuccess = () => {
    return {
        type: actionTypes.INIT_SUCCESS,
    };
};

export const initFail = (error) => {
    return {
        type: actionTypes.INIT_FAIL,
        error: error
    };
};

export const applicationError = (error) => {
    return {
        type: actionTypes.APP_ERROR,
        error: error
    };
};

const delay = (d) => {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            resolve();
        }, d);
    });
};
const envUrl = (s) => {
    return s.replace('%protocol%', window.location.protocol)
        .replace('%hostname%', window.location.hostname)
        .replace('%port%', window.location.port);
};

const libLoaded = () => {
    return new Promise((resolve, reject) => {
        if (typeof window !== 'undefined') {
            window.flow = new window.felib.main(envUrl(process.env.REACT_APP_FELIB_APIURL), { pingtime: 60 });
            
            resolve(window.flow);
        } else {
            return reject('no lib');
        }
    });
};


export const init = () => {
    //console.log(process.env.REACT_APP_FELIB_SCRIPTURL);
    return (dispatch, getState) => {
        dispatch(initStart());

        let cache = scriptCache({ felib: envUrl(process.env.REACT_APP_FELIB_SCRIPTURL) });
        if (cache && cache.felib && cache.felib.tag) {
            cache.felib.tag.promise.then(res => console.log("LOAD SCRIPT"))
                .catch(err => {
                    dispatch(initFail("ScriptLoadError"));
                });
        }
        cache.felib.onLoad(() => {
            libLoaded()
                .then((flow) => {
                    flow.init().then(res => {
                        dispatch(initSuccess());
                        dispatch(authCheckState());
                        dispatch(loadAppModules());
                        dispatch(apiSetGUI());
                        dispatch(apiGetVersion());
                        //console.log(window.flow.socket);
                        //console.log(window.flow);
                        window.flow.socket.addEventListener('close', function(e) {
                            console.log("socket close",e);
                            //dispatch(actions.addMessage("popup.title.admin.granting.save.fail", null, 'text', 'dialog'));
                        });
                        
                        window.flow.socket.addEventListener('error', function(e) {
                            console.log("socket error",e);
                        });
                        
                        window.flow.addEventListener(window.felib.main.event.CLOSE, function(e) {
                            console.log("__CLOSE",e);
                        });
                    }).catch(err => {
                        dispatch(initFail(err));
                    });
                }).catch(err => {
                    dispatch(initFail(err));
                })
        });
    };
};

export const addMessage = (label, text = '', type = 'text', target = 'both') => {
    return {
        type: actionTypes.APP_ADD_MESSAGE,
        payload: {
            message: {
                elementType: type,
                label: label,
                text: text
            },
            target: target
        }
    };

}

export const removeDialog = () => {
    return {
        type: actionTypes.APP_REMOVE_DIALOG
    }
}

const apiSetGUI = () => {
    return dispatch => {
		window.flow.apiSetGUI('Flow2').then((res) => {
            //console.log(res);
        }).catch((res) => {
            console.log(res);
        });
	}
}

const apiGetVersion = () => {
    return dispatch => {
        if(window.flow.apiGetVersion) {
            window.flow.apiGetVersion().then((res) => {
                //console.log(res);
                dispatch({ type: actionTypes.APP_GET_VERSION_SUCCESS, res: res });
            }).catch((res) => {
                console.log(res);
            });
        }
	}
}

const loadAppModules = () => {
    return dispatch => {
		window.flow.getModuleNames().then((modules) => {
            //console.log(modules.modules);
            dispatch({ type: actionTypes.APP_MODULES_LOAD_SUCCESS, modules: modules });
        }).catch((res) => {
            console.log(res);
        });
	}
}

export const initLimitModule = (modules) => {
    return dispatch => {
        //console.log(modules);
        if(modules.includes("mod_limit")) {
            dispatch(actions.getClipLimit(modules));
            dispatch(actions.getUserLimit(modules));
            dispatch(actions.getRoomLimit(modules));
            dispatch(actions.getAppKeys());
            dispatch(actions.getAppProducts());
        } else {
            dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
        }
	}
}

export const getClipLimit = (modules) => {
    return dispatch => {
        if(modules.includes("mod_limit")) {
            window.flow.limitClips().then(obj => {
                //console.log("LIMIT CLIP");
                //console.log(obj);
                dispatch({ type: actionTypes.APP_LIMIT_CLIP, obj: obj });
            }).catch(res => {
                console.log(res);
                dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
            });
        } else {
            dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
        }
    }
}

export const getUserLimit = (modules) => {
    return dispatch => {
        if(modules.includes("mod_limit")) {
            window.flow.limitUsers().then(obj => {
                //console.log("LIMIT USER");
                //console.log(obj);
                dispatch({ type: actionTypes.APP_LIMIT_USER, obj: obj });
            }).catch(res => {
                console.log(res);
                dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
            });
        } else {
            dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
        }
    }
}

export const getRoomLimit = (modules) => {
    return dispatch => {
        if(modules.includes("mod_limit")) {
            window.flow.limitRooms().then(obj => {
                //console.log("LIMIT ROOM");
                //console.log(obj);
                dispatch({ type: actionTypes.APP_LIMIT_ROOM, obj: obj });
            }).catch(res => {
                console.log(res);
                dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
            });
        } else {
            dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
        }
    }
}

export const getAppKeys = () => {
    return (dispatch, getState) => {
        let modules = getState().app.modules.modules;
        if(modules.includes("mod_limit")) {
            window.flow.limitGetKeys().then(obj => {
                //console.log("GET KEYS");
                //console.log(obj);
                dispatch({ type: actionTypes.APP_GET_KEYS, obj: obj });
            }).catch(res => {
                console.log(res);
                dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
            });
        } else {
            dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
        }
    }
}

export const addAppKey = (key) => {
    return (dispatch, getState) => {
        let modules = getState().app.modules.modules;
        if(modules.includes("mod_limit")) {
            window.flow.limitAddKey(key).then(obj => {
                //console.log("ADD KEY");
                //console.log(obj);
                dispatch({ type: actionTypes.APP_ADD_KEY, obj: obj });
                dispatch(actions.getAppProducts());
            }).catch(res => {
                console.log(res);
                dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
            });
        } else {
            dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
        }
    }
}

export const removeAppKey = (key) => {
    return (dispatch, getState) => {
        let modules = getState().app.modules.modules;
        if(modules.includes("mod_limit")) {
            window.flow.limitDelKey(key).then(obj => {
                //console.log("REMOVE KEY");
                //console.log(obj);
                dispatch({ type: actionTypes.APP_REMOVE_KEY, obj: obj });
                dispatch(actions.getAppProducts());
            }).catch(res => {
                console.log(res);
                dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
            });
        } else {
            dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
        }
    }
}

export const getAppProducts = () => {
    return (dispatch, getState) => {
        let modules = getState().app.modules.modules;
        if(modules.includes("mod_limit")) {
            window.flow.limitGetProducts().then(obj => {
                //console.log("GET PRODUCTS");
                //console.log(obj);
                dispatch({ type: actionTypes.APP_GET_PRODUCTS, obj: obj });
            }).catch(res => {
                console.log(res);
                dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
            });
        } else {
            dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
        }
    }
}


export const enableAppProduct = (id, key) => {
    return (dispatch, getState) => {
        let modules = getState().app.modules.modules;
        if(modules.includes("mod_limit")) {
            window.flow.limitEnableProduct(id, key).then(obj => {
                //console.log("ENABLE PRODUCT");
                //console.log(obj);
                dispatch({ type: actionTypes.APP_ENABLE_PRODUCT });
                dispatch(actions.getAppProducts());
            }).catch(res => {
                console.log(res);
                dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
            });
        } else {
            dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
        }
    }
}

export const disableAppProduct = (id, key) => {
    return (dispatch, getState) => {
        let modules = getState().app.modules.modules;
        if(modules.includes("mod_limit")) {
            window.flow.limitDisableProduct(id, key).then(obj => {
                //console.log("DISABLE PRODUCT");
                //console.log(obj);
                dispatch({ type: actionTypes.APP_DISABLE_PRODUCT });
                dispatch(actions.getAppProducts());
            }).catch(res => {
                console.log(res);
                dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
            });
        } else {
            dispatch({ type: actionTypes.APP_MODULE_LIMIT_ERROR });
        }
    }
}

export const checkModule = (prop, module) => {
	return dispatch => {
		if(window.flow.hasOwnProperty(prop)) {
			dispatch({ type: actionTypes.APP_MODULE_SUCCESS, module: module });
		} else {
			dispatch({ type: actionTypes.APP_MODULE_ERROR, module: module });
		}
	}
}
